"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectLoadMessageOnSignOnOption')(function selectLoadMessageOnSignOnOption(loadMessage, state) {
    var optionState = state.optionState;
    optionState.loadMessageOnLogOn = loadMessage;
}));
//# sourceMappingURL=selectLoadMessageOnSignOnOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-reading-pane-option/lib/actions/selectLoadMessageOnSignOnOption.js
// module id = 5117
// module chunks = 2